window.cpap.onDocumentReady(() => {
  // 🚨 This is only for user-blocking logic. Nothing that is user-visible or background should be included here!
  // @see https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API#task_priorities
  window.scheduler.postTask(
    () => {
      const tabClass = 'cpap__simple-tab-menu__tab';
      const tabActiveClass = `${tabClass}--active`;

      const categoryGroupClass = 'cpap__related-blog-articles__card-category-group';
      const categoryGroupActiveClass = `${categoryGroupClass}--active`;

      document.querySelectorAll(`.cpap__related-blog-articles .${tabClass}`).forEach((node) => {
        node.addEventListener('click', (event) => {
          const tabIndex = Number(event.currentTarget.dataset.tabIndex) - 1;

          document.querySelectorAll(`.${tabClass}`).forEach((node) => {
            node.classList.remove(tabActiveClass);
          });

          event.currentTarget.classList.add(tabActiveClass);

          document.querySelectorAll(`.${categoryGroupClass}`).forEach((node) => {
            node.classList.remove(categoryGroupActiveClass);
          });

          document
            .querySelectorAll(`.${categoryGroupClass}`)
            [tabIndex].classList.add(categoryGroupActiveClass);
        });
      });
    },
    { priority: 'user-blocking' }
  );
});
